import React, { ReactElement, useCallback, useEffect } from "react";
import { useProSidebar } from 'react-pro-sidebar';
import "./configurationDashboard.css";

// import {phoneIcon} from "../../../images/phone.svg"
import store from "../../stateManagement/store";
import { resetConfigDashboardTypes, updateActiveConfigType } from "../../stateManagement/actions/configDashboardActions";
import { ConfigurationDashboardNavbar } from "../../components/configurationDashboardNavbar/configurationDashboardNavbar";

import { ConfigurationDashboardSidebar } from "../../components/configurationDashboardSidebar/configurationDashboardSidebar";
import { useLocation, useNavigate } from "react-router-dom";
import { AllSidebarOptions } from "../../configurations/allSidebarOptions";
import { ConfigDashboardTypes } from "../../types";
import { getConfigurationTypes } from "../../services/uiConfigService";
import { configurationsType } from "../updateMetaConfig/UpdateMetaConfigTypes";
import DayEndModal from "../../components/dms_common/DayEndPopup";

interface ConfigDashboardProps{
    children: ReactElement
    sidebarHidden?:boolean
}

export function ConfigurationDashboard(props:ConfigDashboardProps) {
  const { collapsed } = useProSidebar();
  const currentRoute = useLocation().pathname;
  const navigate = useNavigate();

  const activeSidebarOption = AllSidebarOptions.find((sidebarOption) =>
    currentRoute.includes(sidebarOption.route)
  );

  const getAndSetConfigs = useCallback(async () => {
    const layoutConfig = store.getState()?.portalConfigState?.layoutConfig ?? [];
    const configTypes = layoutConfig.find(
      (configObj) => configObj.name === "mainDashboardLayout"
    )?.value ?? [];

    resetConfigDashboardTypes({ configDashboardTypes: configTypes });

    if (activeSidebarOption) {
      updateActiveConfigType(undefined, activeSidebarOption.id);
    } else {
      const sidebarOption = updateActiveConfigType(
        store.getState().configTypeState.configDashboardTypes[0].id
      );
      if (sidebarOption) {
        navigate(sidebarOption.route);
      }
    }
  }, [navigate, activeSidebarOption]);

  useEffect(() => {
    getAndSetConfigs();
  }, [getAndSetConfigs]);

    return (
        <div className="dashboard-container">
            <ConfigurationDashboardNavbar/>
            <div className="dashboard-content">
              {!props.sidebarHidden && <ConfigurationDashboardSidebar/>}
                <div className="dashboard-content-container" style={{width:collapsed || props.sidebarHidden  ? "100%" : "86%"}}>
                    <div className="innerComponent">
                        {props.children}
                    </div>
                </div>
            </div>
            <DayEndModal/>
        </div>

    );
}
